<script setup lang="ts">
import { onMounted, reactive, watch, defineProps, ref, defineEmits } from "vue";
import * as api from "@/api";
import store from "@/store";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
let topBarIndex = 0;
const cid = {
  cid: process.env.VUE_APP_COMPANY,
};
const emits = defineEmits(["scrollToBottom"]);
interface routerArrayData {
  componentId: number;
  name: string;
}
interface toTemplateData {
  id: number;
  name: string;
  // query: Array<routerArrayData>
}
const props = defineProps({
  logo: [],
});
//banner 的数据
const bannerData = ref<any>({});
const pageSrc = reactive({
  log: "页面创建了",
  topBarItems: [] as any,
  topBarIndex: 0,
  logo: "",
  banner: "",
  showBanner: true as boolean,
  fnBox: [] as any,
  keyCode: 0,
});
document.onkeydown = (e: any) => {
  pageSrc.keyCode = e.keyCode;
};
onMounted(() => {
  // console.debug(process.env, 'VUE_APP_APP_CODE');
  let adId = (route as any).query.adId;
  _fnPage.getTopBarItems();
  _fnPage.getFnBox();
  if (adId) {
    _fnPage.getBanner(adId);
  } else {
    router.push("/");
    _fnPage.getBanner(37);
  }
});
watch(
  () => route.fullPath,
  (n, o) => {
    if (n.indexOf("") && !(route as any).query.adId) {
      _fnPage.getBanner(37);
      pageSrc.topBarIndex = 0;
    }
  }
);
class FN_PAGE {
  setColor() {
    let pageAdId: any = route.query.adId;
    const res: any = {
      undefined: 0,
      "37": 0,
      "38": 1,
      "39": 2,
      "40": 3,
      "41": 4,
      "42": 5,
      "43": 6,
    };
    store.commit("setTopbarClickedIndex", res[pageAdId ? pageAdId : undefined]);
  }

  async getBanner(adId: number) {
    pageSrc.showBanner = false;
    try {
      const res = await api.getAdImgAndVideo(adId);
      store.commit("setTopBannerSource", res?.data.ad_list[0].pic);
      if (adId == 37)
        store.commit("setBannerSourceBackUp", res?.data.ad_list[0].pic);
      pageSrc.showBanner = true;
    } catch (e) {
      console.error(e);
    }
    this.setColor();
  }
  toTemplate(item: any, index: number, level: number) {
    if (item.path == "/" && !item?.children) {
      scrollToBottom();
      return;
    }
    if (item.path == "/") {
      return;
    }
    if (item.is_part == 1) return window.open(item.path, "_blank");
    const items = item.path.split("_");
    items[0] = items[0].split("/")[1];
    if (pageSrc.keyCode == 17) {
      pageSrc.keyCode = 0;
      const url: any = router.resolve({
        name: items[0],
        query: {
          componentId: items[1],
          name: encodeURIComponent(item.name),
          waitsources: item.id,
          adId: items[2],
        },
      });
      window.open(url.href);
      return;
    }
    router.push({
      name: items[0],
      query: {
        componentId: items[1],
        name: encodeURIComponent(item.name),
        waitsources: item.id,
        adId: items[2],
      },
    });
    this.getBanner(items[2]);
    if (level == 1) {
      pageSrc.topBarIndex = index;
      store.commit("setTopbarClickedIndex", index);
    } else {
      return;
    }
  }
  async getTopBarItems() {
    try {
      const res = await api.getTopBarItems(cid);
      pageSrc.topBarItems = res.data;
    } catch (e) {
      console.error(e);
    }
  }
  async getFnBox() {
    try {
      const res = await api.getPageMessage(122);
      bannerData.value = res?.data?.content_list[0];
    } catch (e) {
      console.error(e);
    }
  }
}
const _fnPage = new FN_PAGE();

const shwoDrawer = ref(false);
const expandedItems = ref<{ [key: number]: boolean }>({}); // 新增：用于跟踪展开的菜单项
function fun() {
  router.push("/");
}
// 新增：处理抽屉菜单点击事件
function handleDrawerItemClick(item: any, index: number) {
  if (item.children && item.children.length > 0 && index != 0) {
    // 切换子菜单展开状态
    expandedItems.value[index] = !expandedItems.value[index];
  } else {
    // 没有子菜单的项目直接导航
    _fnPage.toTemplate(item, index, 1);
    shwoDrawer.value = false;
  }
}
// 新增：处理子菜单项点击事件
function handleDrawerSubItemClick(
  subItem: any,
  parentIndex: number,
  subIndex: number
) {
  _fnPage.toTemplate(subItem, subIndex, 2);
  shwoDrawer.value = false;
}

const scrollToBottom = () => {
  emits("scrollToBottom", "");
};
</script>
<template>
  <div class="headPage pageWidth">
    <div class="head_content">
      <div class="head flexXBetween pageWidth">
        <div class="head_logo" @click="fun" v-if="props.logo">
          <img class="" :src="props.logo" alt="这个是logo" />
        </div>

        <!-- 平板和移动设备的图标菜单 - 两边对齐 -->
        <div class="hidden-md-and-up head_icon_menu">
          <div class="flexXBetween" style="width: 100%">
            <div></div>
            <el-icon
              @click="shwoDrawer = true"
              color="#333"
              size="22"
              style="cursor: pointer"
              ><Operation
            /></el-icon>
          </div>
          <el-drawer v-model="shwoDrawer" direction="rtl" size="60%">
            <div
              v-for="(item, index) in pageSrc.topBarItems"
              :key="index"
              class="drawerItem"
              @click="handleDrawerItemClick(item, index)"
            >
              <div class="flexXBetween">
                <span>{{ decodeURIComponent(item.name) }}</span>
                <el-icon
                  v-if="item.children && item.children.length > 0 && index != 0"
                >
                  <ArrowRightBold v-if="!expandedItems[index]" />
                  <ArrowDownBold v-else />
                </el-icon>
              </div>
              <!-- 显示子菜单 -->
              <div
                v-if="
                  expandedItems[index] &&
                  item.children &&
                  item.children.length > 0
                "
                class="drawerSubMenu"
              >
                <div
                  v-for="(subItem, subIndex) in item.children"
                  :key="subIndex"
                  class="drawerSubItem"
                  @click.stop="
                    handleDrawerSubItemClick(subItem, index, subIndex)
                  "
                >
                  {{ subItem.name }}
                </div>
              </div>
            </div>
          </el-drawer>
        </div>

        <!-- 桌面版的文字导航菜单 -->
        <div class="hidden-sm-and-down head_anchor">
          <div class="head_anchor_style">
            <div class="head_anchor_links">
              <el-dropdown
                v-for="(item, index) in pageSrc.topBarItems"
                :key="item.id"
                trigger="hover"
              >
                <span
                  class="head_anchor_link"
                  @click.stop="_fnPage.toTemplate(item, index, 1)"
                >
                  {{ item.name }}
                  <el-icon
                    v-if="
                      index != 0 && item.children && item.children.length > 0
                    "
                    class="dropdown-icon"
                  >
                    <ArrowDownBold />
                  </el-icon>
                </span>
                <template
                  #dropdown
                  v-if="index != 0 && item.children && item.children.length > 0"
                >
                  <el-dropdown-menu class="custom-dropdown-menu">
                    <el-dropdown-item
                      v-for="(items, indexs) in item.children"
                      :key="indexs"
                      @click="_fnPage.toTemplate(items, indexs, 2)"
                    >
                      <div class="dropdown-item-content">
                        <div class="dropdown-item-image" v-if="items.litpic">
                          <img
                            :src="items.litpic"
                            :alt="items.name"
                            class="dropdown-item-img"
                          />
                        </div>
                        <div
                          class="dropdown-item-text"
                          :class="{ 'no-image': !items.litpic }"
                        >
                          <h4 class="dropdown-item-title">{{ items.name }}</h4>
                          <p
                            v-if="items.sub_name"
                            class="dropdown-item-subtitle"
                          >
                            {{ items.sub_name }}
                          </p>
                        </div>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="headPage_bgImg flexXBetween" v-if="route.path == '/'">
      <!-- 有标题并且在首页才显示 -->
      <div
        class="headPage_bgImg_text"
        v-if="bannerData?.title && route.path == '/'"
      >
        <h1>{{ bannerData?.title }}</h1>
        <p class="headPage_bgImg_text_sub_title">{{ bannerData?.sub_title }}</p>
        <button class="headPage_bgImg_text_btn" @click="scrollToBottom">
          联系我们
        </button>
      </div>
      <div class="headPage_bgImg_img">
        <img :src="store.state.topBannerSource" alt="这个是背景图片" />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.cc:hover .ccb {
  display: flex;
  opacity: 1 !important;
}
.head_content {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999;
}
.headPage {
  &_bgImg {
    margin-top: 120px;
    &_text {
      width: 50%;
      h1 {
        font-size: 60px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
        font-weight: 300;
        margin-bottom: 20px;
        max-width: 480px;
        line-height: 30px;
        color: #4b5563;
        font-weight: 500;
      }
      button {
        padding: 10px 20px;
        border-radius: 4px;
        border: none;
        background-color: #4f5ceb;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
      }
    }
    &_img {
      width: 50%;
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
        background-color: #fff;
        background-repeat: no-repeat;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .head {
    padding: 0 45px;
  }
}
// 响应式设计 - 平板和移动设备
@media screen and (max-width: 992px) {
  .head {
    padding: 0 20px;
    height: 80px;

    // 图标菜单样式 - 确保两边对齐
    &_icon_menu {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    &_logo {
      margin-right: 15px;
    }
  }
  .headPage {
    &_bgImg {
      &_text {
        h1 {
          font-size: 48px;
        }
      }
    }
  }
}

// 响应式设计 - 移动设备
@media screen and (max-width: 768px) {
  .head {
    padding: 0 15px;

    &_logo {
      width: 80px;
    }
  }

  .headPage {
    &_bgImg {
      // 调整banner容器为垂直排列
      flex-direction: column;

      &_text {
        // 在移动设备上文字占满整个宽度
        width: 100%;
        padding: 20px 10px;
        text-align: left;

        h1 {
          font-size: 24px;
          margin-bottom: 15px;
        }

        p {
          font-size: 16px;
          margin-bottom: 15px;
        }

        button {
          width: 100%;
          padding: 8px 16px;
          font-size: 16px;
        }
      }
      &_img {
        width: 100% !important;
        padding-top: 40px;
      }
    }
  }
}
.head {
  // padding: 0 45px;

  height: 100px;
  position: relative;
  z-index: 9;
  transition: 1s;
  &_logo {
    width: 100px;
    margin-right: 65px;
    cursor: pointer;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  &_menuBar {
    position: absolute;
    right: 0;
    top: 63px;

    &_bar {
      margin: 0 75px 0 0;
      font-size: 18px;
      color: #333;
      position: relative;
      cursor: pointer;
      user-select: none;

      &_flowBox {
        min-width: 90px;
        min-height: 40px;
        // display: none;
        opacity: 0;
        background-color: #fff;
        border-radius: 10px;
        position: absolute;
        color: #000;
        top: 30px;
        left: -8px;
        padding-top: 10px;
        transition: 0.5s;
        z-index: 1000;
        cursor: pointer;
        user-select: none;

        div {
          font-size: 15px;
          margin-bottom: 10px;
        }
      }
    }
  }

  &_anchor {
    flex: 1;
    &_style {
      background: transparent;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    &_links {
      display: flex;
      align-items: center;
      height: 100%;
      gap: 30px; // 增大选项间距
    }
    &_link {
      display: inline-block;
      font-size: 16px;
      color: #4b5563;
      padding: 8px 0;
      cursor: pointer;
      line-height: 24px;
      transition: color 0.3s;
      border: none;
      outline: none;
      text-decoration: none;
      font-weight: 600;
      &:hover {
        color: #06aa65;
        border: none;
        outline: none;
        text-decoration: none;
      }
      i {
        font-size: 12px;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
  }
  .drawerItem {
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    padding: 10px; // 保持较小的padding，控制高度
    transition: background-color 0.3s;
    &:hover {
      background-color: #f5f5f5;
    }
  }
  .drawerSubMenu {
    background-color: #f9f9f9;
    padding-left: 20px;
  }
  .drawerSubItem {
    font-size: 14px;
    padding: 8px 10px;
    cursor: pointer;
    &:hover {
      color: #06aa65;
    }
  }
}
.custom-dropdown-menu {
  padding: 15px 20px !important;
  border-radius: 10px;
  overflow: hidden;
}

.dropdown-item-content {
  display: flex;
  gap: 12px;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px;
}

.dropdown-item-image {
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 4px;
}

.dropdown-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dropdown-item-text {
  max-width: 300px;
  // 文字换行
  word-break: break-word;
  white-space: pre-wrap;
  flex: 1;
}

.dropdown-item-text h4 {
  margin: 0;
  font-size: 15px;
  color: #333;
  margin-bottom: 8px;
}

.dropdown-item-text p {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  line-height: 1.4;
}
</style>
